<template>
  <v-container fluid class="d-flex align-center justify-center fill-height pa-0 h-screen"
    style="background-color: #f6f4f1;"> <v-card elevation="18" width="450" class="pa-8 rounded-xl"
      style="background-color: #ffffff;">
      <div class="text-center mb-8">
        <h2 class="text-h5 font-weight-bold mb-1 text-primary">
          Acesso à Plataforma
        </h2>
        <p class="text-body-2 text-neutrals_muted">
          Utilize suas credenciais para acessar sua área.
        </p>
      </div>

      <v-form @submit.prevent="login" ref="formRef">
        <v-text-field v-model="email" label="E-mail" type="email" prepend-inner-icon="mdi-email-outline"
          variant="outlined" required class="mb-4" color="primary" /> <v-text-field v-model="password"
          :type="passwordVisible ? 'text' : 'password'" label="Senha" prepend-inner-icon="mdi-lock-outline"
          variant="outlined" required :append-inner-icon="passwordVisible ? 'mdi-eye-off' : 'mdi-eye'"
          @click:append-inner="passwordVisible = !passwordVisible" class="mb-6" color="primary" /> <v-btn type="submit"
          block size="large" class="text-white" :loading="loading" :disabled="loading" color="primary"
          style="font-weight:600;"> Entrar
        </v-btn>
      </v-form>

      <div class="d-flex justify-space-between mt-4">
        <a @click.prevent="goToForgotPassword" href="#" class="text-body-2 text-decoration-none text-primary">
          Esqueceu a senha?
        </a>
        <a @click.prevent="goToRegister" href="#" class="text-body-2 text-decoration-none text-primary">
          Criar nova conta
        </a>
      </div>
      <v-snackbar v-model="toast.show" :color="toast.color === 'error' ? 'states_error' : 'states_success'"
        timeout="3000" location="top" variant="tonal">
        {{ toast.message }}
      </v-snackbar>
    </v-card>
  </v-container>
</template>

<script setup>
import { ref } from "vue"
import { useRouter, useRoute } from "vue-router";
import { useStore } from "vuex"
import axios from "axios"

const email = ref("")
const password = ref("")
const passwordVisible = ref(false)
const loading = ref(false)

const toast = ref({
  show: false,
  message: "",
  color: "error",
})

const router = useRouter();
const route = useRoute();
const store = useStore();

const showToast = (message, color = "error") => {
  toast.value = {
    show: true,
    message,
    color,
  }
}

const goToRegister = () => {
  router.push({ name: 'register' });
}

const goToForgotPassword = () => {
  router.push({ name: 'forgot-password' });
}

const login = async () => {
  if (!email.value || !password.value) {
    showToast("Por favor, preencha todos os campos.", "error")
    return
  }

  loading.value = true
  try {
    const response = await store.dispatch("postLogin", {
      email: email.value,
      password: password.value,
    })

    if (!response.user || !response.token) {
      showToast("Erro ao recuperar dados da sessão.", "error")
      loading.value = false
      return
    }

    let redirectTo = "";
    if (response.user.role === 'admin' || response.user.role === 'administrative') {
      redirectTo = route.query.redirect || "/app/dashboard";
    } else {
      redirectTo = route.query.redirect || "/cadastre-seu-anuncio";
    }
    router.push(redirectTo);

  } catch (error) {
    let errorMessage = "Erro desconhecido. Tente novamente.";

    console.error("Login Error:", error.response?.data?.error);
    showToast(error.response?.data?.error || errorMessage, "error");
  } finally {
    loading.value = false;
  }
}
</script>

<style scoped>
/* Adicionando estilos para garantir que o Vuetify use as cores do Tailwind/Paleta */
.text-primary {
  color: #152a34 !important;
  /* PALETTE.primary */
}

.text-neutrals_muted {
  color: #6b7280 !important;
  /* PALETTE.neutrals.muted */
}

.bg-states_error {
  background-color: #ef4444 !important;
  /* PALETTE.states.error */
}

.bg-states_success {
  background-color: #10b981 !important;
  /* PALETTE.states.success */
}
</style>